import CASBlock from "@components/Blocks/CASBlock/CASBlock";
import { CAS_CDP_PAYWALL_ID } from "@helper/getEnvVariables";
import useCasScript from "@hooks/useCasScript";

import RegWallSignupHandler from "./RegwallSignupHandler";

export type ArticleBannerProps = {
  isInfiniteScrollArticle: boolean;
  pageNumber: number;
  isGenG?: boolean;
};

export default function HardRegBanner({
  isInfiniteScrollArticle,
  pageNumber,
}: ArticleBannerProps) {
  const { isScriptReady: isCasScriptReady } = useCasScript();
  const casBlockProps = {
    key: `cas-${CAS_CDP_PAYWALL_ID}`,
    casId: CAS_CDP_PAYWALL_ID,
    ...(isInfiniteScrollArticle && { index: pageNumber }),
  };

  return (
    <div>
      <div className="relative">
        <div className="absolute bg-bg-primary/70 w-full h-[120px] bottom-10 md:bottom-8"></div>
      </div>
      {isCasScriptReady && <CASBlock {...casBlockProps} />}
      <RegWallSignupHandler />
    </div>
  );
}
